import React from 'react'
import { useSelector } from 'react-redux'
const Summarize = () => {
    const data = useSelector(state => state.transcriptionData.data)
    
  return (
    <div>Summarize</div>
  )
}

export default Summarize